module.exports = __webpack_public_path__ + "static/media/security-password-icon.014aae0f.svg";